<template>
  <v-autocomplete
      :multiple="multiple"
      prepend-icon="class"
      :items="items"
      :item-text="'Desc'"
      :item-value="'Id'"
      v-model="item"
      :label="$t('afip.factura.labels.CbteTipo')"
      :loading="loading"
      :error="hasInputErrors('CbteTipo')"
      :error-messages="getInputErrors('CbteTipo')"
      color="secondary"
      item-color="secondary"
      :rules="required"
  ></v-autocomplete>
</template>

<script>

import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'


import AfipProvider from "@/modules/afip/providers/AfipProvider";

export default {
  name: "TipoComprobanteCombobox",
  mixins: [InputErrorsByProps, RequiredRule],
  props: {
    value: {
      type: [String, Number, Array]
    },
    multiple: {type: Boolean, default: false}
  },
  data() {
    return {
      items: [],
      loading: false
    }
  },
  computed: {
    item: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    fetch() {
      this.loading = true
      AfipProvider.getTipoComprobantes().then(r => {
        this.items = r.data.getTipoComprobantes
      }).catch(err => console.error(err))
          .finally(() => this.loading = false)
    }

  }
}
</script>

<style scoped>

</style>

